/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'
import variablesApplicationConfig from '../../../../variables'

export const ContainerSectionServicesCircularYearsExperience = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;

  margin-top: 50px;

  .middle-section {
    width: 100%;
    max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px;

    margin-top: 120px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 100px;

    .m-s-left {
      width: 50%;
      position: relative;
      .m-s-l-image {
        width: 400px;
        height: 500px;

        margin-left: 100px;

        background-color: #d9d9d9;

        border-radius: 20px;
      }
      .m-s-l-box-circle {
        position: absolute;
        top: 50px;
        left: 50px;

        width: 400px;
        height: 500px;

        border-radius: 20px;

        border: 5px solid
          ${(props) =>
            props.color ? 'var(--secondary-color)' : 'var(--primary-color)'};
      }

      .m-s-l-float-years {
        position: absolute;
        bottom: 50px;
        right: 50px;
        width: 240px;

        background-color: var(--primary-color);

        border-radius: 20px;

        padding: 20px 30px;

        display: flex;
        align-items: center;

        color: white;

        .date {
          font-size: 50px;
          font-weight: bold;
          margin-right: 20px;
        }
      }
    }

    .m-s-right {
      color: ${(props) =>
        props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};
      width: 50%;
      .m-s-r-label {
        font-weight: 700;
        font-size: 18px;
        font-family: var(--secondary-font-family);

        display: flex;
        align-items: center;

        svg {
          width: 50px !important;
          margin-top: 6px;
          margin-left: 10px;
        }
      }
      .m-s-r-title {
        font-size: 50px;
        line-height: 60px;
        font-weight: bold;
        margin-top: 10px;
        transition: all 0.6s ease-in-out;
        color: black;
      }

      .m-s-r-box-list {
        margin-top: 30px;

        .m-s-r-service {
          margin-bottom: 20px;

          .m-s-r-service-box-top {
            display: flex;
            gap: 20px;

            align-items: flex-start;

            /* margin-bottom: 14px; */

            .m-s-r-service-box-top-icon {
              font-size: 23px;
              margin-top: 3px;
            }
            .m-s-r-service-box-top-title {
              font-size: 22px;
              font-weight: bold;
            }
          }
          .m-s-r-service-box-top-description {
            margin-left: 44px;
            font-size: 16px;
            line-height: 30px;
            color: #727272;
            font-style: italic;
          }
        }
      }

      .m-s-r-service-see-more {
        display: flex;
        width: min-content;
        background-color: var(--primary-color);
        color: white;
        white-space: nowrap;

        margin-top: 30px;

        padding: 16px 26px 17px;

        border-radius: 100px;

        cursor: pointer;

        font-weight: 600;

        svg {
          font-size: 20px;
          margin-left: 10px;
        }
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    .middle-section {
      align-items: center !important;

      flex-direction: column-reverse !important;
      .m-s-left {
        width: 100% !important;
        display: flex;
        justify-content: center !important;
        align-items: center !important;
        .m-s-l-image {
          width: 250px !important;
          height: 350px !important;

          position: absolute;
        }
        .m-s-l-box-circle {
          position: relative !important;
          top: 30px !important;
          left: 0 !important;

          width: 250px !important;
          height: 350px !important;
        }
      }
      .m-s-right {
        width: 100% !important;
        max-width: 100% !important;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center !important;
        justify-content: center !important;

        margin-bottom: 50px;

        .m-s-r-label {
          width: 100% !important;
          max-width: 100% !important;
          text-align: center;
          justify-content: center;
          flex-direction: column;
          gap: 20px;

          svg {
            margin-left: 0px;
          }
        }

        .m-s-r-title {
          width: 100% !important;
          max-width: 50% !important;
          font-size: 30px !important;
          line-height: 40px !important;
        }

        .m-s-r-service-box-top {
          margin-top: 50px;
          text-align: center;
          display: flex;
          justify-content: center;

          svg {
            display: none;
          }
        }
        .m-s-r-box-list {
          margin-top: 0;
          width: 100% !important;
          max-width: 100% !important;
          display: flex;
          flex-direction: column;
          align-items: center !important;

          .m-s-r-service {
            width: 100% !important;
            max-width: 50% !important;
            margin-bottom: 10px;
            .m-s-r-service-box-top-title {
              margin-bottom: 20px;
            }
            .m-s-r-service-box-top-description {
              margin-left: 0 !important;
              padding: 0px 30px;
            }
          }
        }
      }
    }
  }
  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    margin-top: 0px;
    .middle-section {
      align-items: center !important;

      flex-direction: column-reverse !important;
      .m-s-left {
        width: 100% !important;
        display: flex;
        justify-content: center !important;
        align-items: center !important;
        .m-s-l-image {
          width: 250px !important;
          height: 350px !important;

          position: absolute;
        }
        .m-s-l-box-circle {
          position: relative !important;
          top: 30px !important;
          left: 0 !important;

          width: 250px !important;
          height: 350px !important;
        }
      }
      .m-s-right {
        width: 100% !important;
        max-width: 100% !important;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center !important;
        justify-content: center !important;

        margin-bottom: 50px;

        .m-s-r-label {
          width: 100% !important;
          max-width: 100% !important;
          text-align: center;
          justify-content: center;
          flex-direction: column;
          gap: 20px;

          svg {
            margin-left: 0px;
          }
        }

        .m-s-r-title {
          width: 100% !important;
          max-width: 80% !important;
          font-size: 30px !important;
          line-height: 40px !important;
        }

        .m-s-r-service-box-top {
          margin-top: 50px;
          text-align: center;
          display: flex;
          justify-content: center;

          svg {
            display: none;
          }
        }
        .m-s-r-box-list {
          margin-top: 0;
          width: 100% !important;
          max-width: 100% !important;
          display: flex;
          flex-direction: column;
          align-items: center !important;

          .m-s-r-service {
            width: 100% !important;
            max-width: 80% !important;
            margin-bottom: 10px;
            .m-s-r-service-box-top-title {
              margin-bottom: 20px;
            }
            .m-s-r-service-box-top-description {
              margin-left: 0 !important;
              padding: 0px 0px;
            }
          }
        }
      }
    }
  }
`
